import request from "@/utils/request";
const index = {
  // 列表
  list(query) {
    return request({
      url: "/bianminfenlei/list",
      method: "get",
      params: query
    });
  },
  // 新增
  create(data) {
    return request({
      url: "/bianminfenlei/create",
      method: "post",
      data
    });
  },
  // 编辑
  edit(data) {
    return request({
      url: "/bianminfenlei/edit",
      method: "post",
      data
    });
  },
  // 详情
  detail(query) {
    return request({
      url: "/bianminfenlei/detail",
      method: "post",
      params: query
    });
  },
  // 删除
  remove(data) {
    return request({
      url: "/bianminfenlei/remove",
      method: "post",
      data
    });
  },
  // 状态
  status(data) {
    return request({
      url: "/bianminfenlei/status",
      method: "post",
      data
    });
  },
  // 排序
  sort(data) {
    return request({
      url: "/notice/sort",
      method: "post",
      data
    });
  },
  // 下拉选
  select(query) {
    return request({
      url: "/bianminfenlei/select",
      method: "post",
      params: query
    });
  },
};
export default index;